import { mixCandidateSeed } from "./prng.js";
export const GPU_DUTY_SHADOW_SCHEMA_VERSION = 1;
export const GPU_DUTY_ALGORITHM_VERSION = "packed-duty-explicit-limits-generation-v4";
export const GPU_DUTY_SHADER_VERSION = "generate-and-score-explicit-limits-wgsl-v4";
export const DEFAULT_GPU_CANARY_MODULO = 100;
const FNV_PRIME = 16777619;
function updateHash(hash, value) {
    let next = hash >>> 0;
    const word = value >>> 0;
    for (let shift = 0; shift < 32; shift += 8) {
        next ^= (word >>> shift) & 0xff;
        next = Math.imul(next, FNV_PRIME) >>> 0;
    }
    return next;
}
function hashArray(hashes, fieldTag, values) {
    let first = updateHash(hashes[0], fieldTag);
    let second = updateHash(hashes[1], fieldTag ^ 2779096485);
    first = updateHash(first, values.length);
    second = updateHash(second, values.length);
    for (const value of values) {
        first = updateHash(first, value);
        second = updateHash(second, value ^ 2654435769);
    }
    return [first, second];
}
/**
 * GPU 실행에 영향을 주는 숫자형 Packed 입력만 hash한다.
 * metadata의 날짜, 간호사 ID, Shift ID는 의도적으로 포함하지 않는다.
 */
export function hashPackedDutyInput(input) {
    let hashes = [2166136261, 1818371886];
    const header = new Uint32Array([
        input.version,
        input.nurseCount,
        input.shiftCount,
        input.dayCount,
        input.shiftBitWords,
    ]);
    hashes = hashArray(hashes, 1, header);
    hashes = hashArray(hashes, 2, input.requirements);
    hashes = hashArray(hashes, 3, input.fixedAssignments);
    hashes = hashArray(hashes, 4, input.availability);
    hashes = hashArray(hashes, 5, input.availableShiftBits);
    hashes = hashArray(hashes, 6, input.shiftFlags);
    hashes = hashArray(hashes, 7, input.rules);
    return `${hashes[0].toString(16).padStart(8, "0")}${hashes[1].toString(16).padStart(8, "0")}`;
}
export function detectGpuRuntimeProfile(userAgent) {
    const runtime = globalThis;
    const normalized = (userAgent ?? runtime.navigator?.userAgent ?? "").toLowerCase();
    let browserFamily = "other";
    if (/firefox|fxios/.test(normalized))
        browserFamily = "firefox";
    else if (/edg|chrome|chromium|crios/.test(normalized))
        browserFamily = "chromium";
    else if (/safari/.test(normalized))
        browserFamily = "safari";
    let osFamily = "other";
    if (/iphone|ipad|ipod|macintosh.*mobile/.test(normalized))
        osFamily = "ios";
    else if (/android/.test(normalized))
        osFamily = "android";
    else if (/windows/.test(normalized))
        osFamily = "windows";
    else if (/macintosh|mac os x/.test(normalized))
        osFamily = "macos";
    else if (/linux/.test(normalized))
        osFamily = "linux";
    return { browserFamily, osFamily };
}
export function shouldVerifyGpuCanaryCandidate(runSeed, candidateIndex, canaryModulo = DEFAULT_GPU_CANARY_MODULO) {
    if (!Number.isInteger(runSeed) || runSeed < 0 || runSeed > 4294967295) {
        throw new RangeError("runSeed는 u32 범위의 정수여야 합니다.");
    }
    if (!Number.isInteger(candidateIndex) || candidateIndex < 0 || candidateIndex > 4294967295) {
        throw new RangeError("candidateIndex는 u32 범위의 정수여야 합니다.");
    }
    if (!Number.isSafeInteger(canaryModulo) || canaryModulo < 1) {
        throw new RangeError("canaryModulo는 1 이상의 안전한 정수여야 합니다.");
    }
    return candidateIndex === 0 || mixCandidateSeed(runSeed, candidateIndex) % canaryModulo === 0;
}
export function isAnonymousGpuShadowDiagnostic(diagnostic) {
    const serialized = JSON.stringify(diagnostic).toLowerCase();
    return !/(nurseids|shiftids|dates|email|name|useragent)/.test(serialized);
}
//# sourceMappingURL=shadow.js.map